module.exports = __webpack_public_path__ + "img/pf.2a69c581.svg";